import { baseSchema, Update } from './base'
import { generate } from './generate'
import { z } from 'zod'

export const clientSchema = baseSchema.extend({
  branchId: z.string().nullish(),
  userId: z.string(),
  color: z.string(),
  createdAt: z.number(),
  lastActiveAt: z.number(),
  selection: z
    .object({
      blockId: z.string(),
      awareness: z.string().nullish(),
      activeTabKey: z.string().nullish(),
    })
    .nullable(),
})

export type Client = z.infer<typeof clientSchema>
export type ClientUpdate = Update<Client>

export const clientBaseOps = generate('client', clientSchema.parse)
